
import { useEffect, useState } from "react";
import LayoutPage from "../../Components/LayoutPage";
import NavLayer2 from "../../Components/NavLayer2/NavLayer2";
import ResetPassWordCard from "./Components/ResetPassWordCard";
import VerificationCard from "./Components/VerificationCard";
import VerificationModalGuide from "./Components/VerificationModalGuide";
import VerificationModalOn from "./Components/VerificationModalOn";
import VerificationModalOff from "./Components/VerificationModalOff";
import { useNavigate } from "react-router-dom";
import TableLoading from "../../Components/Loader/TableLoading";
import { API_BASE_URL } from "../../config/api";

export default function Secutiry() {
  const navigate = useNavigate();
  const [showGuide, setShowGuide] = useState(false);
  const [showVerificationOn, setShowVerificationOn] = useState(false);
  const [showVerificationOff, setShowVerificationOff] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [twofaData, setTwofaData] = useState(null);
  const [twofaInitLoading, setTwofaInitLoading] = useState(false);

  const [accLoading, setAccLoading] = useState(true);

  const fetchTwoAuthStatus = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}auth/2fa/status/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}auth/trader/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          navigate("/signin");
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}auth/2fa/status/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setIsVerified(data.twofa_enabled);
      setAccLoading(false);
    } catch (error) {
      setAccLoading(false);
      console.error("Error fetching account data:", error);
    }
  };
  const fetchTwoAuthInit = async () => {
    setTwofaInitLoading(true);
    setTwofaData(null);
    try {
      let response = await fetch(
        `${API_BASE_URL}auth/2fa/init/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}auth/trader/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          navigate("/signin");
          return false; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}auth/2fa/init/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      setTwofaData(data.data);
      console.log("Account Data:", data);
      return true;
    } catch (error) {
      console.error("Error fetching account data:", error);
      return false;
    } finally {
      setTwofaInitLoading(false);
    }
  };
  useEffect(() => {
    fetchTwoAuthStatus();
  }, []);
  return (
    <LayoutPage
      activeIndex={12}
      navItems={["حساب کاربری"]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5"
    >
      <NavLayer2
        texts={["اطلاعات حساب", "امنیت حساب", "احراز هویت"]}
        hrefs={["/profile/information", "/profile/security", "/profile/kyc"]}
        activeIndex={1}
      />
      <div className="w-full h-fit flex flex-col items-center gap-5 min-h-0 overflow-y-auto">
        {!accLoading ? (
          <>
            <VerificationCard
              onToggle={async () => {
                if (twofaInitLoading) return;
                if (!isVerified) {
                  const initSuccess = await fetchTwoAuthInit();
                  if (initSuccess) setShowGuide(true);
                  return;
                } else {
                  setShowVerificationOff(true);
                }
                return;
              }}
              isOn={isVerified}
              isLoading={twofaInitLoading}
            />
            <ResetPassWordCard />
            {showGuide && (
              <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur"
                onClick={() => setShowGuide(false)}
              >
                <div
                  className="w-11/12 max-w-sm"
                  onClick={(e) => e.stopPropagation()}
                >
                  <VerificationModalGuide
                    data={twofaData}
                    onNext={() => {
                      setShowGuide(false);
                      setShowVerificationOn(true);
                    }}
                    onClose={() => setShowGuide(false)}
                  />
                </div>
              </div>
            )}
            {showVerificationOn && (
              <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur"
                onClick={() => setShowVerificationOn(false)}
              >
                <div
                  className="w-11/12 max-w-sm"
                  onClick={(e) => e.stopPropagation()}
                >
                  <VerificationModalOn
                    setShowGuide={setShowGuide}
                    setShowVerificationOn={setShowVerificationOn}
                    isVerified={isVerified}
                    setIsVerified={setIsVerified}
                  />
                </div>
              </div>
            )}
            {showVerificationOff && (
              <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur"
                onClick={() => setShowVerificationOff(false)}
              >
                <div
                  className="w-11/12 max-w-sm"
                  onClick={(e) => e.stopPropagation()}
                >
                  <VerificationModalOff
                    setShowVerificationOff={setShowVerificationOff}
                    isVerified={isVerified}
                    setIsVerified={setIsVerified}
                  />
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="w-full flex justify-center items-center gap-2">
            <p className="text-[#808080]">در حال بارگذاری</p>
            <TableLoading className="text-[#808080]" />
          </div>
        )}
      </div>
    </LayoutPage>
  );
}
